export default {
    bgColor: 0xff3af4,
    primaryKey: "BGElmnts_Skl",
    secondaryKey: "BGElmnts_Cld2",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        let deltaScale = 1 - (data.scaleX/1);
        image.setPosition(data.x, data.y);
        image.angle = -90;
        image.setScale(0);
        image.alpha = 0;

        bg.scene.addTween(image, 3500, {angle: data.angle, delay: deltaScale * 1000}, "Elastic");
        bg.scene.addTween(image, 700, {scaleX: data.scaleX, scaleY: data.scaleY, alpha: 1, delay: deltaScale * 1000}, Phaser.Math.Easing.Sine.Out);
    },
    animateOut: (image, bg)=>{
        let deltaScale = 1 - (image.scaleX/1);
        bg.scene.addTween(image, 500, {scaleX: 0, scaleY: 0, delay: deltaScale * 400}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_Skl",
            x: 645.112040589036, y: 432.1985216473073,
            angle: 6,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 251.6726147753991, y: 473.4244984160507,
            angle: -19,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 846.7493379532236, y: 512.272439281943,
            angle: -24,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 817.7976983046653, y: 232.64202745512145,
            angle: 16,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Skl",
            x: 187.98252691498578, y: 234.3738120380148,
            angle: -13,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Skl",
            x: 388.72971166934786, y: 685.4139387539599,
            angle: 26,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Skl",
            x: 424.7724490728054, y: 408.8017817371938,
            angle: -12,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Skl",
            x: 637.7266048101894, y: 683.3318485523386,
            angle: -12,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 25.100314502342457, y: 429.630289532294,
            angle: -12,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Skl",
            x: 637.0161296637044, y: 179.88864142538975,
            angle: -12,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 1022.1625624763471, y: 175.73051224944322,
            angle: 14,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_Skl",
            x: 846.5493351081184, y: 11.091314031180403,
            angle: -24,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 387.1419958501351, y: 183.02004454342986,
            angle: 26,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Skl",
            x: -3.7282490962951353, y: 175.74387527839644,
            angle: 14,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_Skl",
            x: 252.42207258348668, y: -29.86859688195991,
            angle: -18,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 1047.0311370368922, y: 428.445434298441,
            angle: -11,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnts_Skl",
            x: 189.00306672408618, y: 740.4610244988864,
            angle: -11,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Skl",
            x: -3.14919938926516, y: 678.7661469933184,
            angle: 13,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_Skl",
            x: 644.4237429693719, y: -69.32962138084633,
            angle: 6,
            scaleX: 0.8999999999999999,
            scaleY: 0.8999999999999999
        },{
            key: "BGElmnts_Skl",
            x: 1019.0444740241945, y: 676.1870824053452,
            angle: 12,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_Skl",
            x: 817.0369703376007, y: 734.804008908686,
            angle: 17,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Skl",
            x: 32.900259692805605, y: -64.32962138084633,
            angle: -9,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnts_Skl",
            x: 523.9800075689361, y: 535.2182628062361,
            angle: 14,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Skl",
            x: 906.7054900886088, y: 343.93541202672606,
            angle: 25,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Skl",
            x: 139.57072387738324, y: 70.6815144766147,
            angle: 34,
            scaleX: 0.39999999999999963,
            scaleY: 0.39999999999999963
        },{
            key: "BGElmnts_Skl",
            x: 525.5590572759661, y: 32.195991091314035,
            angle: 14,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Skl",
            x: 521.2695324224511, y: 282.9376391982183,
            angle: -20,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Skl",
            x: 140.10976262250585, y: 574.1380846325167,
            angle: 37,
            scaleX: 0.39999999999999963,
            scaleY: 0.39999999999999963
        }
    ]
}